// extracted by mini-css-extract-plugin
export default {"summary_empty":"summary_summary_empty__6J5Bt","summary__products":"summary_summary__products__fEyEh","summary__checkout":"summary_summary__checkout__BPzDn"};